var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 67,
    viewBox: "0 0 165 67",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.001%",
    cy: "49.955%",
    fx: "50.001%",
    fy: "49.955%",
    r: "53.827%",
    gradientTransform: "matrix(1 0 0 .8711 0 .064)",
    id: "logo-bond_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008CD1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00427E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "51.832%",
    cy: "50.004%",
    fx: "51.832%",
    fy: "50.004%",
    r: "188.333%",
    gradientTransform: "matrix(.20131 0 0 1 .414 0)",
    id: "logo-bond_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.182%",
    cy: "49.999%",
    fx: "52.182%",
    fy: "49.999%",
    r: "188.78%",
    gradientTransform: "matrix(.26802 0 0 1 .382 0)",
    id: "logo-bond_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.032%",
    cy: "50.001%",
    fx: "50.032%",
    fy: "50.001%",
    r: "50.655%",
    gradientTransform: "matrix(.97463 0 0 1 .013 0)",
    id: "logo-bond_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8",
    offset: "26.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "53.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1CD",
    offset: "62.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BCBC",
    offset: "76.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA0",
    offset: "92.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.048%",
    cy: "50.006%",
    fx: "50.048%",
    fy: "50.006%",
    r: "50.652%",
    gradientTransform: "matrix(.97491 0 0 1 .013 0)",
    id: "logo-bond_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8",
    offset: "26.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "53.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1CD",
    offset: "62.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BCBC",
    offset: "76.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA0",
    offset: "92.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.038%",
    cy: "50.001%",
    fx: "50.038%",
    fy: "50.001%",
    r: "50.654%",
    gradientTransform: "matrix(.97477 0 0 1 .013 0)",
    id: "logo-bond_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8",
    offset: "26.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "53.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1CD",
    offset: "62.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BCBC",
    offset: "76.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA0",
    offset: "92.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.954%",
    cy: "49.998%",
    fx: "49.954%",
    fy: "49.998%",
    r: "50.652%",
    gradientTransform: "matrix(.97491 0 0 1 .013 0)",
    id: "logo-bond_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8",
    offset: "26.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "53.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1CD",
    offset: "62.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BCBC",
    offset: "76.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA0",
    offset: "92.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.042%",
    cy: "50.007%",
    fx: "50.042%",
    fy: "50.007%",
    r: "51.306%",
    gradientTransform: "matrix(.95092 0 0 1 .025 0)",
    id: "logo-bond_svg__s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8",
    offset: "26.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "53.99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1CD",
    offset: "62.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BCBC",
    offset: "76.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA0",
    offset: "92.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.045%",
    cy: "50.002%",
    fx: "50.045%",
    fy: "50.002%",
    r: "70.748%",
    gradientTransform: "matrix(.57693 0 0 1 .212 0)",
    id: "logo-bond_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008CD1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00427E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.979%",
    cy: "50.009%",
    fx: "49.979%",
    fy: "50.009%",
    r: "111.729%",
    gradientTransform: "matrix(.33357 0 0 1 .333 0)",
    id: "logo-bond_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.045%",
    cy: "50.006%",
    fx: "50.045%",
    fy: "50.006%",
    r: "58.561%",
    gradientTransform: "matrix(.75718 0 0 1 .122 0)",
    id: "logo-bond_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.047%",
    cy: "50.012%",
    fx: "50.047%",
    fy: "50.012%",
    r: "71.12%",
    gradientTransform: "matrix(.57298 0 0 1 .214 0)",
    id: "logo-bond_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.997%",
    cy: "49.972%",
    fx: "49.997%",
    fy: "49.972%",
    r: "69.833%",
    gradientTransform: "matrix(1 0 0 .5872 0 .206)",
    id: "logo-bond_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.029%",
    cy: "50.01%",
    fx: "50.029%",
    fy: "50.01%",
    r: "54.492%",
    gradientTransform: "matrix(.85257 0 0 1 .074 0)",
    id: "logo-bond_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.02%",
    fx: "50%",
    fy: "50.02%",
    r: "86.105%",
    gradientTransform: "matrix(1 0 0 .45015 0 .275)",
    id: "logo-bond_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.005%",
    cy: "50.053%",
    fx: "50.005%",
    fy: "50.053%",
    r: "57.813%",
    gradientTransform: "matrix(1 0 0 .77304 0 .114)",
    id: "logo-bond_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.008%",
    cy: "50.024%",
    fx: "50.008%",
    fy: "50.024%",
    r: "93.879%",
    gradientTransform: "matrix(1 0 0 .40666 0 .297)",
    id: "logo-bond_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.025%",
    cy: "49.991%",
    fx: "50.025%",
    fy: "49.991%",
    r: "111.751%",
    gradientTransform: "matrix(-.33351 0 0 -1 .667 1)",
    id: "logo-bond_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.048%",
    cy: "49.994%",
    fx: "50.048%",
    fy: "49.994%",
    r: "58.565%",
    gradientTransform: "matrix(-.75718 0 0 -1 .88 1)",
    id: "logo-bond_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.956%",
    cy: "49.988%",
    fx: "49.956%",
    fy: "49.988%",
    r: "71.125%",
    gradientTransform: "matrix(-.57287 0 0 -1 .786 1)",
    id: "logo-bond_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.997%",
    cy: "50.02%",
    fx: "49.997%",
    fy: "50.02%",
    r: "69.818%",
    gradientTransform: "matrix(-1 0 0 -.58761 1 .794)",
    id: "logo-bond_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.97%",
    cy: "49.99%",
    fx: "49.97%",
    fy: "49.99%",
    r: "54.482%",
    gradientTransform: "matrix(-.85279 0 0 -1 .926 1)",
    id: "logo-bond_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.019%",
    cy: "49.98%",
    fx: "50.019%",
    fy: "49.98%",
    r: "86.097%",
    gradientTransform: "matrix(-1 0 0 -.45036 1 .725)",
    id: "logo-bond_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.992%",
    cy: "50.047%",
    fx: "49.992%",
    fy: "50.047%",
    r: "57.818%",
    gradientTransform: "matrix(-1 0 0 -.7728 1 .887)",
    id: "logo-bond_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.004%",
    cy: "49.976%",
    fx: "50.004%",
    fy: "49.976%",
    r: "93.879%",
    gradientTransform: "matrix(-1 0 0 -.40666 1 .703)",
    id: "logo-bond_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCB26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3760D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "logo-bond_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5A3",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAEAB",
    offset: "2.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C5C1",
    offset: "10.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3CE",
    offset: "18.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "24.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "74.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4CF",
    offset: "79.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C7C5",
    offset: "85.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB3B4",
    offset: "91.47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F969C",
    offset: "97.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.99%",
    x2: "100%",
    y2: "49.99%",
    id: "logo-bond_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.029%",
    x2: "100%",
    y2: "50.029%",
    id: "logo-bond_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.961%",
    x2: "100%",
    y2: "49.961%",
    id: "logo-bond_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "logo-bond_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.039%",
    x2: "100%",
    y2: "50.039%",
    id: "logo-bond_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.493%",
    y1: "49.98%",
    x2: "100.602%",
    y2: "49.98%",
    id: "logo-bond_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.561%",
    y1: "50.02%",
    x2: "101.675%",
    y2: "50.02%",
    id: "logo-bond_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.094%",
    y1: "49.961%",
    x2: "103.21%",
    y2: "49.961%",
    id: "logo-bond_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.18%",
    y1: "50%",
    x2: "105.3%",
    y2: "50%",
    id: "logo-bond_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.979%",
    y1: "49.941%",
    x2: "108.105%",
    y2: "49.941%",
    id: "logo-bond_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00386E",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    offset: "42.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDB",
    offset: "53.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D0",
    offset: "63.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBC",
    offset: "73.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A1",
    offset: "83.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00437E",
    offset: "93.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002660",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.267%",
    y1: "49.994%",
    x2: "89.846%",
    y2: "49.994%",
    id: "logo-bond_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90979D",
    offset: "6.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BBBB",
    offset: "20.27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "29.45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "69.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3C1",
    offset: "75.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA3A7",
    offset: "85.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889097",
    offset: "94.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "logo-bond_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5A3",
    offset: ".48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BDBA",
    offset: "5.58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD1CC",
    offset: "11.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "14.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2",
    offset: "51.53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8D3",
    offset: "87.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFCB",
    offset: "89.67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B6B6",
    offset: "93.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868D95",
    offset: "99.45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818991",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.932 33.932v-5.81l1.648-.094c2.072-.117 4.291.872 4.291 3.151 0 2.235-1.96 3.13-3.891 2.942l-2.048-.19v.001zm-2.387-1.43c0 1.083.14 2.801-1.035 3.247v.072h3.872c1.776 0 3.648.07 5.304-.73 1.582-.753 2.832-2.308 2.832-4.121 0-2.306-1.721-3.721-3.849-4.169 1.35-.589 2.363-1.485 2.363-3.06 0-2.097-1.819-3.415-4.946-3.415H45.51v.072c1.2.446 1.035 2.166 1.035 3.225v8.88-.001zm2.387-5.937v-4.613l1.577-.165c1.412-.144 2.92.705 2.92 2.33 0 1.93-2.19 2.448-3.72 2.448h-.777zm18.048-4.939c3.72 0 5.911 3.314 5.911 6.744 0 3.5-2.284 6.109-5.864 6.109-3.695 0-6.026-3.383-6.026-6.673 0-3.55 2.33-6.18 5.98-6.18h-.001zm.165-1.702c-4.943-.119-8.81 3.63-8.81 8.093 0 4.817 3.914 8.165 8.575 8.165 4.684 0 8.643-3.487 8.643-8.28.002-4.231-3.464-8-8.408-7.978zm11.79 12.843c0 1.318-.023 2.258 1.221 2.99v.071h-4.17v-.072c1.246-.73 1.246-1.671 1.246-2.989v-9.394c0-1.32 0-2.26-1.224-2.967v-.07h3.443v.024c.094.283.19.4.354.589l.327.47 8.592 10.876v-8.922c0-1.32.023-2.26-1.22-2.967v-.07h4.15v.07c-1.226.707-1.226 1.647-1.226 2.967v13.21c-1.681-.567-2.406-1.343-3.443-2.686l-8.05-10.24v9.11zm17.036-10.484a9.296 9.296 0 012.118-.26c3.93 0 6.233 2.075 6.233 6.191 0 4.072-3.125 5.908-6.634 5.908a8.304 8.304 0 01-1.717-.166V22.283zm-2.384 10.154c0 1.39.142 2.52-1.036 3.319v.071h5.634c5.269 0 8.804-3.248 8.804-7.887 0-4.685-3.323-7.604-8.687-7.604h-5.75v.07c1.2.355 1.035 2.07 1.035 3.156v8.875zM57.154 52.786c-1.04 1.37-2.981 1.937-4.638 1.937-1.562 0-3.217-.496-4.269-1.625-1.24-1.366-1.193-2.941-1.193-4.638v-6.286c0-1.059.164-2.776-1.036-3.224v-.071h4.464v.071c-1.183.448-1.042 2.165-1.042 3.224v6.286c0 3.133 1.326 4.59 3.762 4.59 1.326 0 2.675-.54 3.456-1.648.52-.702.496-1.293.496-2.141v-7.086c0-1.058.141-2.775-1.04-3.223v-.072h4.463l.023.072c-1.2.448-1.06 2.165-1.06 3.248v8.874c0 1.06-.14 2.779 1.06 3.226v.07h-3.446v-1.584zm7.111-1.478c0 1.32-.023 2.26 1.22 2.99v.07h-4.17v-.07c1.248-.73 1.248-1.67 1.248-2.99v-9.395c0-1.315 0-2.258-1.225-2.964v-.072h3.443v.023c.094.284.188.4.352.59l.33.471 8.592 10.877v-8.925c0-1.315.022-2.258-1.223-2.964v-.072h4.149v.072c-1.224.705-1.224 1.647-1.224 2.964v13.21c-1.68-.565-2.405-1.342-3.439-2.685l-8.053-10.239v9.11-.001zm14.651-9.11c0-1.084.166-2.802-1.035-3.248v-.072h4.46v.072c-1.178.447-1.037 2.189-1.037 3.248v8.873c0 1.06-.141 2.78 1.036 3.227v.07h-4.459v-.07c1.176-.424 1.035-2.167 1.035-3.227v-8.873z",
    fill: "#002B60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3 43.141c.632-1.672 1.43-3.6-.023-4.192v-.072h3.5L90.561 55.08c-1.65-1.088-2.195-1.274-2.88-3.137l-3.552-9.628c-.446-1.201-.798-2.564-1.827-3.365v-.072h3.42l-.023.284c0 .52.449 1.672.638 2.19l3.753 10.24 3.21-8.45v-.001zm7.935 9.248l2.99.284c1.553.14 3.178-.356 4.357-1.392h.069l-1.057 3.085h-9.801v-.07c1.199-.425 1.06-2.168 1.06-3.226v-8.882c0-1.083.139-2.801-1.06-3.247v-.074h7.516c.403 0 .8.05 1.108-.117h.07v2.754h-.07c-.73-.847-1.695-.94-2.78-.94-.823 0-1.646.023-2.4.166v4.376h2.803c.375 0 .752 0 1.035-.142h.07v2.502h-.07c-.377-.683-1.365-.66-2.094-.66h-1.743v5.583h-.003zm13.355-13.525c3.16 0 4.867 1.651 4.867 3.792 0 2.074-1.803 3.698-3.733 4.144l3.38 4.261c.987 1.225 2.47 2.448 3.811 3.295h-2.164c-1.248 0-2.02-.307-2.723-1.175l-2.87-3.555-2.173-3.319c1.89-.282 4.086-1.152 4.086-3.365 0-1.696-1.464-2.685-3.046-2.613-.544.022-1.064.093-1.605.186V51.07c0 1.086-.143 2.802 1.06 3.227v.07h-4.482v-.07c1.199-.425 1.035-2.166 1.035-3.227v-8.872c0-1.084.164-2.802-1.035-3.248v-.072l5.592-.014z",
    fill: "#002B60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.684 41.687c-.912-.94-2.367-1.478-3.685-1.478-1.339 0-3.031.516-3.031 2.134 0 3.215 8.072 3.17 8.072 7.51 0 2.51-2.618 4.87-6.285 4.87-1.437 0-2.863-.213-4.195-.708l-.68-2.942c1.381 1.199 3.3 1.95 5.132 1.95 1.342 0 3.364-.798 3.364-2.44 0-3.66-8.072-3.005-8.072-7.977 0-2.963 3.016-4.097 5.885-4.097 1.176 0 2.375.164 3.495.52v2.658zm3.15.511c0-1.084.164-2.802-1.035-3.248v-.072h4.458v.072c-1.176.447-1.035 2.189-1.035 3.248v8.873c0 1.06-.14 2.78 1.035 3.227v.07H133.8v-.07c1.176-.424 1.035-2.167 1.035-3.227v-8.873h-.001z",
    fill: "#002B60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 51.302c0 1.339-.025 2.258 1.22 2.988v.071h-4.643v-.071c1.175-.448 1.036-2.165 1.036-3.224v-10.5h-2.071c-1.013 0-2.074.259-2.802.941h-.07l.824-2.808h.072c.282.119.586.119.893.164h9.354c.401 0 .777-.023 1.082-.164h.074l-.755 2.808h-.07c-.306-.824-1.248-.94-2.025-.94h-2.117l-.002 10.735z",
    fill: "#002B60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21 51.308c0 1.412 0 2.12 1.2 2.99v.07h-4.574v-.07c1.153-.59.987-2.12.987-3.227V47.59l-3.906-6.287c-.635-1.035-1.106-1.812-2.238-2.425h2.144c.753 0 1.458.166 1.765.662l3.757 6.143 2.913-4.38c.402-.59.942-1.717-.376-2.353v-.072h4.12l-5.79 8.71v3.721h-.002v-.001z",
    fill: "#002B60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.052 30.098V19.746H29.954v-1.084h8.175l-4.492-3.52 2.542-3.938-4.668-1.11.741-4.87-4.547.813-1.027-4.624-4.07 2.504L19.897 0l-2.71 3.916-4.071-2.504-1.028 4.624-4.547-.813.74 4.87-4.667 1.11 2.542 3.939-4.492 3.519H9.84v1.084H0l.002 10.326c-.008.227-.443 22.838 19.584 35.282l.441.274.44-.274C40.496 52.91 40.06 30.3 40.053 30.098h-.001z",
    stroke: "#2E2E2E",
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__a)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.217 30.098V20.58H.836v9.518S.176 52.31 20.027 64.646c19.85-12.335 19.19-34.548 19.19-34.548z",
    fill: "url(#logo-bond_svg__b)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.812 48.035c-1.854-.963-3.258-1.584-5.871.025-2.614 1.613-4.185 2.123-6.626.623-2.44-1.5-3.903-1.565-3.903-1.565-1.528-.036-2.145.543-4.463 1.759-1.667.874-2.631.83-3.042.734.51.952 1.07 1.912 1.685 2.865.853-.199 1.723-.608 2.472-.989.98-.496 2.657-2.114 6.288-.106 3.631 2.005 4.274 1.648 7.395-.081 3.12-1.729 4.388-.938 6.684.226.9.457 1.544.66 2.085.745a39.876 39.876 0 001.582-2.708c-1.735-.01-2.771-.742-4.286-1.528z",
    stroke: "#E6E7E8",
    strokeWidth: 0.058,
    fill: "url(#logo-bond_svg__c)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.775 54.587c-1.854-.962-3.257-1.584-5.871.025-2.614 1.613-4.185 2.122-6.625.623-2.44-1.5-3.904-1.565-3.904-1.565-1.396-.033-2.036.45-3.906 1.461a39.14 39.14 0 001.835 2.208c1.055-.473 2.602-.737 5.01.594 3.63 2.006 4.274 1.648 7.395-.08 2.323-1.286 3.619-1.177 5.078-.558.659-.74 1.278-1.49 1.857-2.248-.278-.147-.563-.302-.869-.46h0z",
    stroke: "#E6E7E8",
    strokeWidth: 0.058,
    fill: "url(#logo-bond_svg__d)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__e)",
    fillRule: "nonzero",
    d: "M.953 22.234h38.189v1H.953z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__f)",
    fillRule: "nonzero",
    d: "M.953 24.699h38.189v1H.953z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__g)",
    fillRule: "nonzero",
    d: "M.953 27.165h38.189v1H.953z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__h)",
    fillRule: "nonzero",
    d: "M.953 29.631h38.189v1H.953z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__i)",
    fillRule: "nonzero",
    d: "M.953 32.097h38.189v1H.953z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14 34.562c.034.266.074.549.116.834h37.541c.043-.288.083-.568.118-.834H1.139h.001z",
    fill: "url(#logo-bond_svg__j)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.693 37.862H38.36c.06-.287.111-.561.163-.835H1.53c.05.273.103.548.162.835h.001z",
    fill: "url(#logo-bond_svg__k)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.275 40.328h35.504c.074-.284.143-.561.21-.835H2.064c.068.275.136.552.21.835h.001z",
    fill: "url(#logo-bond_svg__l)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.004 42.794H37.05c.092-.282.175-.56.26-.836H2.743c.085.278.168.554.261.836z",
    fill: "url(#logo-bond_svg__m)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.897 45.26h32.26c.11-.281.216-.56.318-.835H3.578c.103.275.208.554.319.835z",
    fill: "url(#logo-bond_svg__n)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.217 30.698V21.18H1.836v9.518s-.66 22.213 19.191 34.548c19.85-12.335 19.19-34.548 19.19-34.548z",
    stroke: "#E0E0E0",
    strokeWidth: 0.181
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#E6E7E8"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__o)",
    d: "M14.223 5.817l1.623 1.291.002-2.074 2.022-.463-1.621-1.294.898-1.87-2.022.46L14.223 0l-.901 1.867-2.023-.46.899 1.87-1.621 1.294 2.021.463.002 2.074z",
    transform: "translate(6.707 23.049)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__p)",
    d: "M3.647 13.209l1.623 1.292.002-2.075 2.022-.464-1.621-1.294.898-1.87-2.023.46-.901-1.868-.901 1.868-2.023-.46.898 1.87L0 11.962l2.022.464.002 2.075z",
    transform: "translate(6.707 23.049)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__q)",
    d: "M14.393 23.256l1.623 1.291.002-2.074 2.022-.463-1.621-1.294.899-1.871-2.022.46-.903-1.867-.901 1.867-2.023-.46.899 1.871-1.621 1.294 2.021.463.002 2.074z",
    transform: "translate(6.707 23.049)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__r)",
    d: "M24.992 10.617l1.624 1.293.002-2.075 2.022-.462-1.621-1.296.898-1.869-2.023.46-.902-1.869-.901 1.869-2.022-.46.898 1.869-1.621 1.296 2.021.462.003 2.075z",
    transform: "translate(6.707 23.049)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.144,
    fill: "url(#logo-bond_svg__s)",
    d: "M19.758 16.221l-1.178.819.416-1.372-1.144-.868 1.435-.03.471-1.353.471 1.353 1.433.03-1.143.868.416 1.372z",
    transform: "translate(6.707 23.049)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bond_svg__t)",
    fillRule: "nonzero",
    d: "M10.606 18.394h18.571v1.413H10.606z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.675 19.714v-1.888h-6.59l3.186-2.495-2.315-3.586 4.267-1.016-.681-4.477 4.187.75.948-4.262 3.746 2.305 2.474-3.576 2.473 3.576 3.747-2.305.948 4.262 4.186-.75-.68 4.476 4.267 1.016-2.315 3.586 3.186 2.496h-6.59v1.887l-7.396-1.03s-.595.998-1.756.998c-1.162 0-1.804-1.033-1.804-1.033l-7.488 1.066h0z",
    stroke: "#FFFCE1",
    strokeWidth: 0.181,
    fill: "url(#logo-bond_svg__u)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__v)",
    fillRule: "nonzero",
    d: "M10.654 17.479l.049-1.168-3.121-.681-2.452 1.859z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__w)",
    fillRule: "nonzero",
    d: "M5.609 12.151l5.045 2.089v1.731l-3.021-.682z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__x)",
    fillRule: "nonzero",
    d: "M5.79 11.868l3.565-.765 1.299.947v1.84z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__y)",
    fillRule: "nonzero",
    d: "M9.005 6.905l.635 3.967 1.014.764v-1.363l1.129-.167z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__z)",
    fillRule: "nonzero",
    d: "M9.244 6.752l2.981 3.302.892-.122-.009-1.693-.355-.836z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__A)",
    fillRule: "nonzero",
    d: "M13.891 3.799l-.774 3.456.225.529 1.965.88V7.218z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__B)",
    fillRule: "nonzero",
    d: "M14.179 3.667l1.498 3.276 1.748.923V5.571z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__C)",
    fillRule: "nonzero",
    d: "M19.723 2.526v4.837l-1.967-1.221v-.823z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__D)",
    fillRule: "nonzero",
    d: "M29.177 17.479l-.05-1.168 3.123-.681 2.451 1.859z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__E)",
    fillRule: "nonzero",
    d: "M34.222 12.151l-5.045 2.089v1.731l3.02-.682z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__F)",
    fillRule: "nonzero",
    d: "M34.042 11.868l-3.565-.765-1.3.947v1.84z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__G)",
    fillRule: "nonzero",
    d: "M30.827 6.905l-.635 3.967-1.015.764v-1.363l-1.13-.167z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__H)",
    fillRule: "nonzero",
    d: "M30.587 6.752l-2.981 3.302-.891-.122.007-1.693.356-.836z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__I)",
    fillRule: "nonzero",
    d: "M25.941 3.799l.774 3.456-.226.529-1.965.88V7.218z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__J)",
    fillRule: "nonzero",
    d: "M25.652 3.667l-1.497 3.276-1.748.923V5.571z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFCE1",
    strokeWidth: 0.108,
    fill: "url(#logo-bond_svg__K)",
    fillRule: "nonzero",
    d: "M20.108 2.526v4.837l1.967-1.221v-.823z",
    transform: "translate(1 .6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.604 10.944v5.671s-1.515-1-5.276.842a1.408 1.408 0 00-.101-.296c2.557-1.783 5.02-1.15 5.02-1.15V8.365c-1.306.33-1.717 1.044-1.717 1.044v5.904c-1.58.177-2.844 1.243-3.36 1.742a1.467 1.467 0 00-.28-.35c1.009-1.25 3.186-1.855 3.186-1.855V7.512c-1.305.329-1.716 1.042-1.716 1.042v5.747a5.373 5.373 0 00-1.632 2.27 1.404 1.404 0 00-.448-.195c.301-1.163 1.684-2.31 1.684-2.31V6.833c-1.305.33-1.715 1.044-1.715 1.044v5.745c.004 1.552-.006 2.354-.015 2.74a1.428 1.428 0 00-.594 0c-.01-.386-.019-1.188-.014-2.74V7.876s-.412-.715-1.716-1.044v7.235s1.383 1.146 1.684 2.31a1.4 1.4 0 00-.447.193 5.388 5.388 0 00-1.633-2.27V8.555s-.411-.713-1.716-1.042v7.338s2.177.605 3.186 1.854a1.42 1.42 0 00-.278.35c-.515-.497-1.782-1.564-3.36-1.741V9.41s-.412-.713-1.717-1.044v7.646s2.462-.632 5.02 1.15c-.043.094-.08.193-.101.296-3.76-1.842-5.277-.842-5.277-.842v-5.671c-.697-.096-1.71.224-1.71.224V18.6c3.06-1.439 6.01-1.104 6.965-.938-.002.03-.01.058-.01.088a1.422 1.422 0 002.844 0c0-.03-.006-.058-.009-.088.955-.166 3.904-.5 6.966.938v-7.433c-.001 0-1.015-.32-1.713-.224v.001z",
    stroke: "#2E2E2E",
    strokeWidth: 0.144,
    fill: "url(#logo-bond_svg__L)",
    fillRule: "nonzero",
    transform: "translate(1 .6)"
  }))));
}

export default SvgLogoBond;